import { MessageTypes } from "~proto"

/** 内容字段承载可搜索文案的消息类型（非图片/语音等媒体 URL） */
const SEARCHABLE_MESSAGE_TYPES = new Set<number>([
  MessageTypes.TEXT,
  MessageTypes.ORDER,
  MessageTypes.NEW_TRANS,
  MessageTypes.RED_PACKET,
  MessageTypes.GAME_NOTICE,
])

const MEDIA_MESSAGE_TYPES = new Set<number>([
  MessageTypes.VOICE,
  MessageTypes.IMAGE,
  MessageTypes.VIDEO,
  MessageTypes.IMAGES,
  MessageTypes.FILE,
  MessageTypes.EMOJI,
])

export function getSearchableMessageContent(message: {
  type?: number
  content?: string | null
}): string {
  if (!message || message.type == null) return ""
  if (MEDIA_MESSAGE_TYPES.has(message.type)) return ""
  const content = (message.content ?? "").toString().trim()
  if (!content) return ""
  if (SEARCHABLE_MESSAGE_TYPES.has(message.type)) return content
  return ""
}

export function isSearchableMessage(message: {
  type?: number
  content?: string | null
}): boolean {
  return getSearchableMessageContent(message).length > 0
}
